import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';

@Component({
  selector: 'out-auth-callback',
  imports: [CommonModule],
  templateUrl: './auth-callback.component.html',
  styleUrl: './auth-callback.component.scss',
})
export class AuthCallbackComponent {
  private auth = inject(AuthService);
  private router = inject(Router);

  constructor() {
    this.auth.appState$.subscribe((state: any) => {
      const target = state?.target || '/';
      this.router.navigateByUrl(target);
    });
  }
}
